"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var end2end_1 = require("@hudled/end2end");
var interfaces_1 = require("@hudled/interfaces");
var react_1 = __importDefault(require("react"));
var react_final_form_1 = require("react-final-form");
var validators_1 = require("utils/form/validators");
var FormAutocomplete_1 = __importDefault(require("./FormAutocomplete"));
var FieldCountryCodeSelect = function (_a) {
    var name = _a.name;
    var countryCodeOptions = react_1.default.useMemo(function () { return interfaces_1.COUNTRY_CODES.map(function (code) { return ({ value: code, label: (0, end2end_1.getRegionName)(code) }); }); }, []);
    return ((0, jsx_runtime_1.jsx)(react_final_form_1.Field, { component: FormAutocomplete_1.default, validate: (0, validators_1.required)(), name: name, options: countryCodeOptions, size: "small", label: "Select Country", disableClearable: true }));
};
exports.default = FieldCountryCodeSelect;
